
    import { Component, Vue } from 'vue-property-decorator';
    import { mapState } from 'vuex';
    import { DataTableHeaders } from '@/types';
    import Reiseplan from '@/types/Reiseplan';
    import _ from 'lodash';
    import moment from 'moment';

    @Component({
        computed: {
            ...mapState('patient', ['reiseplaene', 'loaders']),
            ...mapState('patient', ['aktuelleAnzeigen']),
        },
    })
    export default class PlaeneDatatable extends Vue {
        public get headers(): DataTableHeaders<Reiseplan> {
            return [
                {text: '', value: 'actions', sortable: false, width: 50},
                {text: 'Datum', value: 'datum'},
                {text: 'Abreisedatum', value: 'abreisedatum'},
                {text: 'Reisedauer', value: 'reisedauer'},
                {text: 'Reiseziele / Reiseart / Bemerkung', value: 'text'},
            ];
        }

        public aktuelleAnzeigen!: any;
        public reiseplaene!: any;

        get filteredItems() {
            var retval: any[] = [];
            var intervall = moment().subtract(6, 'months').format('YYYY-MM-DD');
            _.forEach(this.reiseplaene, (item: any) => {
                if (this.aktuelleAnzeigen === 'j') {
                    if (item.datum > intervall) {
                        retval.push(item);
                    }
                } else {
                    retval.push(item);
                }
            });

            return retval;
        }
    }

